export default __webpack_public_path__ + "static/media/withdrawal.bf5bada4.webp";